/*
================================================================ 
          Copyright (c) 2018-2020 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

export default {
  default: "Month",
  a: "Month",
  b: "Year",
  priceFunction(price, id, promo, t) {
    let pPrice = null;
    let isSpecialPriceRecurring = false;

    // This IF contruct is for prices set for each item
    if (promo && promo.priceAdjustments) {
      if (promo.priceAdjustments[id]) {
        if (promo.priceAdjustments[id].price) {
          pPrice = promo.priceAdjustments[id].price;
        } else {
          pPrice = null;
        }
      }
    }

    // This IF Construct is for OPEX special pricing. It is in a acent stage
    // Make this solid once discussed well
    if (
      promo &&
      promo.name.includes("OPEX") &&
      !price.recurringPrice &&
      price.purchasePrice > 0
    ) {
      if (promo.name.includes("OPEX-12")) {
        pPrice = (price.purchasePrice / 12).toFixed(2);
        isSpecialPriceRecurring = true;
      } else if (promo.name.includes("OPEX-24")) {
        pPrice = (price.purchasePrice / 24).toFixed(2);
        isSpecialPriceRecurring = true;
      } else if (promo.name.includes("OPEX-36")) {
        pPrice = (price.purchasePrice / 36).toFixed(2);
        isSpecialPriceRecurring = true;
      } else {
        pPrice = null;
      }
    }

    if (parseInt(price.purchasePrice) === -1 && pPrice === null) {
      return null;
    } else if (parseInt(pPrice) === -1) {
      return null;
    } else if (price.recurringPrice) {
      if (price.recurringPrice.price === 0) {
        return "";
      }
      return (
        Math.round((pPrice ? pPrice : price.recurringPrice.price) * 100) / 100
      ).toFixed(2);
    } else if (isSpecialPriceRecurring) {
      if (pPrice === 0) {
        return "";
      }
      return (Math.round((pPrice ? pPrice : 0) * 100) / 100).toFixed(2);
    } else {
      return (
        Math.round((pPrice ? pPrice : price.purchasePrice) * 100) / 100
      ).toFixed(2);
    }
  },
};
